/**
 * Comparator function to sort objects by their custom date strings in ascending order.
 * The date string format is assumed to be "MM/DD - HH:mm".
 * If the year is not provided, the current year is assumed.
 *
 * @param {{ date: string }} a - First object containing a date string to compare.
 * @param {{ date: string }} b - Second object containing a date string to compare.
 * @returns {number} - Negative if `a` is earlier than `b`, positive if `a` is later than `b`, zero if equal.
 */

/** Distinct fills for vitals charts when multiple devices plot on the same graph */
export const CHART_DEVICE_PALETTE = [
    'lightgrey',
    '#7a6b78',
];

/** Stable device name → color map (sorted names so order does not jump when data refreshes). */
export function buildDeviceColorMap(deviceNames) {
    const sorted = [...deviceNames].sort((a, b) => String(a).localeCompare(String(b)));
    const map = {};
    sorted.forEach((name, i) => {
        map[name] = CHART_DEVICE_PALETTE[i % CHART_DEVICE_PALETTE.length];
    });
    return map;
}

export function sortData(a, b) {
    const [datePart, timePart] = a.date.split('-');
        const [monthA, dayA] = datePart.split('/');
        const yearA = new Date().getFullYear(); // Assume current year if not provided
        const dateStrA = `${yearA}/${monthA}/${dayA} ${timePart}`;

        const [datePart2, timePart2] = b.date.split('-');
        const [monthB, dayB] = datePart2.split('/');
        const yearB = new Date().getFullYear();
        const dateStrB = `${yearB}/${monthB}/${dayB} ${timePart2}`;

        return new Date(dateStrA) - new Date(dateStrB);
};